import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';

import HelpText from '../../components/help/HelpText';

import { adminUser, renderErrorWarning, renderErrors, capitalize } from '../../utilities/Forms.js'
import { hideResidentsCheck, renderPlannedEventOrAppointment, TYPE_OF_PEOPLE } from '../../utilities/Generic.js'
import Audits from '../../components/shared/Audits';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {request, handleRequestErrors} from '../../helpers/Requests'

class UpdatePlannedEventSettings extends Component {

  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator();

    this.handleChange = this.handleChange.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this)
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    "confirmation": ["email"],
    "amendment": ["email"],
    "removal": ["email"],
    "reminder": ["email"],

    "visitor_reminders": ["same day"],
    "resident_reminders": ["same day"],
    "staff_reminders": ["same day"],
    "contractor_reminders": ["same day"],
    "industry professional_reminders": ["same day"],
    "agency_reminders": ["same day"],
    "volunteer_reminders": ["same day"],
    "other_reminders": ["same day"],

    "visitor_link_text": "",
    "resident_link_text": "",
    "staff_link_text": "",
    "contractor_link_text": "",
    "industry professional_link_text": "",
    "agency_link_text": "",
    "volunteer_link_text": "",
    "other_link_text": "",

    "visitor_link_url": "",
    "resident_link_url": "",
    "staff_link_url": "",
    "contractor_link_url": "",
    "industry professional_link_url": "",
    "agency_link_url": "",
    "volunteer_link_url": "",
    "other_link_url": "",

    tabIndex: 0,

    hideResidents: hideResidentsCheck(),
    plannedEventOrAppointment: renderPlannedEventOrAppointment(),

    loaded: false,
    unauthorized: "",
    error: "",
    errors: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
    this.validator.hideMessages();
  }

  handleMultiCheckbox(event) {
    let name = event.target.name;
    let setName = event.target.dataset.name;
    let value = event.target.checked;

    var set = this.state[setName]

    if (value === true) {
      if (name === "none") {
        set = []
      }
      else if (!set.includes(name)) {
        set.push(name)
      }
    }
    else if (value === false) {
      if (set.includes(name)) {
        let index = set.indexOf(name)
        set.splice(index, 1)
      }
    }

    this.setState({[setName]: set});
  }

  handleTabChange(index) {
    this.setState({ tabIndex: index });
  }

  handleSubmit(event) {
    if (this.validator.allValid()) {
      this.setState({
        success: false,
        updating: true
      })

      var json = JSON.stringify({
        "organisation_settings": {
          "planned_event_notifications": {
            "confirmation": this.constructNotificationParams("confirmation"),
            "amendment": this.constructNotificationParams("amendment"),
            "removal": this.constructNotificationParams("removal"),
            "reminder": this.constructNotificationParams("reminder")
          },
          "planned_event_settings": {
            "visitor": this.constructReminderParams("visitor"),
            "resident": this.constructReminderParams("resident"),
            "staff": this.constructReminderParams("staff"),
            "contractor": this.constructReminderParams("contractor"),
            "industry professional": this.constructReminderParams("industry professional"),
            "agency": this.constructReminderParams("agency"),
            "volunteer": this.constructReminderParams("volunteer"),
            "other": this.constructReminderParams("other")
          }
        }
      })

      request("PUT", `/v1/a/organisation_settings/0`, json, () => {this.setState({unauthorized: true})})
        .then(data => {
          this.setState({
            "confirmation": this.parseNotifications(data.planned_event_notifications["confirmation"]),
            "amendment": this.parseNotifications(data.planned_event_notifications["amendment"]),
            "removal": this.parseNotifications(data.planned_event_notifications["removal"]),
            "reminder": this.parseNotifications(data.planned_event_notifications["reminder"]),

            "visitor_reminders": this.parseReminders(data.planned_event_settings["visitor"].reminders),
            "resident_reminders": this.parseReminders(data.planned_event_settings["resident"].reminders),
            "staff_reminders": this.parseReminders(data.planned_event_settings["staff"].reminders),
            "contractor_reminders": this.parseReminders(data.planned_event_settings["contractor"].reminders),
            "industry professional_reminders": this.parseReminders(data.planned_event_settings["industry professional"].reminders),
            "agency_reminders": this.parseReminders(data.planned_event_settings["agency"].reminders),
            "volunteer_reminders": this.parseReminders(data.planned_event_settings["volunteer"].reminders),
            "other_reminders": this.parseReminders(data.planned_event_settings["other"].reminders),

            "visitor_link_text": data.planned_event_settings["visitor"].link_text,
            "resident_link_text": data.planned_event_settings["resident"].link_text,
            "staff_link_text": data.planned_event_settings["staff"].link_text,
            "contractor_link_text": data.planned_event_settings["contractor"].link_text,
            "industry professional_link_text": data.planned_event_settings["industry professional"].link_text,
            "agency_link_text": data.planned_event_settings["agency"].link_text,
            "volunteer_link_text": data.planned_event_settings["volunteer"].link_text,
            "other_link_text": data.planned_event_settings["other"].link_text,

            "visitor_link_url": data.planned_event_settings["visitor"].link_url,
            "resident_link_url": data.planned_event_settings["resident"].link_url,
            "staff_link_url": data.planned_event_settings["staff"].link_url,
            "contractor_link_url": data.planned_event_settings["contractor"].link_url,
            "industry professional_link_url": data.planned_event_settings["industry professional"].link_url,
            "agency_link_url": data.planned_event_settings["agency"].link_url,
            "volunteer_link_url": data.planned_event_settings["volunteer"].link_url,
            "other_link_url": data.planned_event_settings["other"].link_url,

            errors: "",
            updating: false
          })
          sessionStorage.setItem("updateSuccess", `${this.state.plannedEventOrAppointment} Settings updated successfully!`);
          this.props.updatePopupCallback(Math.random())
        })
        .catch(error => handleRequestErrors(this, error, { loaded: true }))
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }

    event.preventDefault();
  }

  constructNotificationParams(notification) {
    return this.state[notification].length === 0 ? ["no notification"] : this.state[notification]
  }

  constructReminderParams(type_of_person) {
    return {
      reminders: this.state[`${type_of_person}_reminders`].length === 0 ? ["no reminder"] : this.state[`${type_of_person}_reminders`],
      link_text: this.state[`${type_of_person}_link_text`],
      link_url: this.state[`${type_of_person}_link_url`]
    }
  }

  parseNotifications(notifications) {
    if (notifications === null) {
      return ["email"]
    }

    if (notifications[0] === "no notification") {
      return []
    }

    return notifications
  }

  parseReminders(reminders) {
    if (reminders === null) {
      return ["same day"]
    }

    if (reminders[0] === "no reminder") {
      return []
    }

    return reminders
  }

  renderSaveButton() {
    if (adminUser()) {

      return (
        <input type="submit" disabled={this.state.updating} value="Save" />
      )
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  renderTabErrorIndicator(type_of_person) {
    if (this.validator.messagesShown === true && this.validator.errorMessages[`${type_of_person}_link_url`] !== null) {
      return (
        <span className="notification-indicator red" />
      )
    }
  }

  render() {

    const { tabIndex, hideResidents, reminder, plannedEventOrAppointment, loaded, unauthorized, errors, error } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/> 
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      let type_of_people = TYPE_OF_PEOPLE

      if (hideResidents) {
        type_of_people = type_of_people.filter(type_of_person => type_of_person !== "resident")
      }

      const bookingNotifications = ["confirmation", "amendment", "removal", "reminder"]

      return (
        <div>
          <form className="settings big-settings segment-settings top-padding" onSubmit={this.handleSubmit}>
            <div className="segment">
              <label className="column"><strong>Notification Types:</strong></label>
              <HelpText page={'planned_event_settings'} section={'notification_types'} plannedEventOrAppointment={plannedEventOrAppointment} />
              <div className="reminder-table">
                <div className="reminder-option header">
                </div>
                <div className="reminder-option header">
                  <label>Email</label>
                </div>

                <div className="reminder-option header">
                  <label>SMS</label>
                </div>

                <div className="reminder-option header">
                  <label>No notifications</label>
                </div>
                {bookingNotifications.map((notification) => (
                  <React.Fragment key={notification}>
                    <div className="reminder-option text">
                      Booking {capitalize(notification)}s
                    </div>

                    <div className="reminder-option">
                      <input className="column" type="checkbox" data-name={notification} name="email" id={`email_${notification}`} checked={this.state[notification].includes("email")} onChange={this.handleMultiCheckbox} />
                    </div>

                    <div className="reminder-option">
                      <input className="column" type="checkbox" data-name={notification} name="sms" id={`sms_${notification}`} checked={this.state[notification].includes("sms")} onChange={this.handleMultiCheckbox} />
                    </div>

                    <div className="reminder-option">
                      <input className="column" type="checkbox" data-name={notification} name="none" id={`no_${notification}`} checked={this.state[notification].length === 0} onChange={this.handleMultiCheckbox} />
                    </div>
                  </React.Fragment>
                ))}
              </div>

            </div>

            {reminder.length > 0 &&
              <>
                <div className="segment">
                  <label className="column"><strong>Reminder notifications:</strong></label>
                  <HelpText page={'planned_event_settings'} section={'reminders'} plannedEventOrAppointment={plannedEventOrAppointment} />
                  <div className="reminder-table">
                    <div className="reminder-option header">
                    </div>
                    <div className="reminder-option header">
                      <label>One day before</label>
                    </div>

                    <div className="reminder-option header">
                      <label>Day of</label>
                    </div>

                    <div className="reminder-option header">
                      <label>No reminder</label>
                    </div>
                    {type_of_people.map((type_of_person) => (
                      <React.Fragment key={type_of_person}>
                        <div className="reminder-option text">
                          {capitalize(type_of_person)}
                        </div>

                        <div className="reminder-option">
                          <input className="column" type="checkbox" data-name={`${type_of_person}_reminders`} name="one day" id={`${type_of_person} one day`} checked={this.state[`${type_of_person}_reminders`].includes("one day")} onChange={this.handleMultiCheckbox} />
                        </div>

                        <div className="reminder-option">
                          <input className="column" type="checkbox" data-name={`${type_of_person}_reminders`} name="same day" id={`${type_of_person} same day`} checked={this.state[`${type_of_person}_reminders`].includes("same day")} onChange={this.handleMultiCheckbox} />
                        </div>

                        <div className="reminder-option">
                          <input className="column" type="checkbox" data-name={`${type_of_person}_reminders`} name="none" id={`${type_of_person} no reminder`} checked={this.state[`${type_of_person}_reminders`].length === 0} onChange={this.handleMultiCheckbox} />
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                </div>

                <div className="segment">
                  <HelpText page={'planned_event_settings'} section={'link'} plannedEventOrAppointment={plannedEventOrAppointment} />
                  <label className="small-bottom-padding"><strong>Reminder email footer links:</strong></label>
                  <Tabs selectedIndex={tabIndex} onSelect={index => this.handleTabChange(index)}>
                    <TabList>
                      {type_of_people.map((type_of_person) => (
                        <Tab key={type_of_person}>{capitalize(type_of_person)} {this.renderTabErrorIndicator(type_of_person)}</Tab>
                      ))}
                    </TabList>

                    {type_of_people.map((type_of_person) => (
                      <TabPanel key={type_of_person}>
                        { renderErrors(errors, type_of_person) }
                        <div className="row">
                          <HelpText page={'planned_event_settings'} section={'link_text'} plannedEventOrAppointment={plannedEventOrAppointment} />

                          <label className="column">Email Link Text:</label>
                          <input className="column" type="input" name={`${type_of_person}_link_text`} value={this.state[`${type_of_person}_link_text`]} onChange={this.handleChange} />
                        </div>

                        <div className="row">
                          <HelpText page={'planned_event_settings'} section={'link_url'} plannedEventOrAppointment={plannedEventOrAppointment} />

                          <label className="column">Email Link URL:</label>
                          {this.validator.message(`${type_of_person}_link_url`, this.state[`${type_of_person}_link_url`], "url", { className: 'error' })}
                          <input className="column" type="input" name={`${type_of_person}_link_url`} value={this.state[`${type_of_person}_link_url`]} onChange={this.handleChange} />
                        </div>

                        <div className="row">
                          <HelpText page={'planned_event_settings'} section={'link_preview'} plannedEventOrAppointment={plannedEventOrAppointment} />

                          <label className="column">Email Link Preview:</label>
                          <a className="link-preview" target="_blank" rel="noopener noreferrer" href={this.state[`${type_of_person}_link_url`]}>{this.state[`${type_of_person}_link_text`]}</a>
                        </div>
                      </TabPanel>
                    ))}
                  </Tabs>
                </div>
              </>
            }

            <div className="segment">
              {type_of_people.map((type_of_person) => (
                <React.Fragment key={type_of_person}>
                  {this.validator.message(`${type_of_person}_link_url`, this.state[`${type_of_person}_link_url`], "url", { className: 'error' })}
                </React.Fragment>
              ))}
              { renderErrors(errors, "planned_event_settings")}
              { this.renderSaveButton() }
              { renderErrorWarning(errors) }
            </div>
          </form>

          <Audits klass="OrganisationSettings" id={0} />
        </div>
      );
    }
  }

  componentDidMount() {
    request("GET", `/v1/a/organisation_settings/0`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        this.setState({
          "confirmation": this.parseNotifications(data.planned_event_notifications["confirmation"]) || [],
          "amendment": this.parseNotifications(data.planned_event_notifications["amendment"]) || [],
          "removal": this.parseNotifications(data.planned_event_notifications["removal"]) || [],
          "reminder": this.parseNotifications(data.planned_event_notifications["reminder"]) || [],

          "visitor_reminders": this.parseReminders(data.planned_event_settings["visitor"].reminders),
          "resident_reminders": this.parseReminders(data.planned_event_settings["resident"].reminders),
          "staff_reminders": this.parseReminders(data.planned_event_settings["staff"].reminders),
          "contractor_reminders": this.parseReminders(data.planned_event_settings["contractor"].reminders),
          "industry professional_reminders": this.parseReminders(data.planned_event_settings["industry professional"].reminders),
          "agency_reminders": this.parseReminders(data.planned_event_settings["agency"].reminders),
          "volunteer_reminders": this.parseReminders(data.planned_event_settings["volunteer"].reminders),
          "other_reminders": this.parseReminders(data.planned_event_settings["other"].reminders),

          "visitor_link_text": data.planned_event_settings["visitor"].link_text || "",
          "resident_link_text": data.planned_event_settings["resident"].link_text || "",
          "staff_link_text": data.planned_event_settings["staff"].link_text || "",
          "contractor_link_text": data.planned_event_settings["contractor"].link_text || "",
          "industry professional_link_text": data.planned_event_settings["industry professional"].link_text || "",
          "agency_link_text": data.planned_event_settings["agency"].link_text || "",
          "volunteer_link_text": data.planned_event_settings["volunteer"].link_text || "",
          "other_link_text": data.planned_event_settings["other"].link_text || "",

          "visitor_link_url": data.planned_event_settings["visitor"].link_url || "",
          "resident_link_url": data.planned_event_settings["resident"].link_url || "",
          "staff_link_url": data.planned_event_settings["staff"].link_url || "",
          "contractor_link_url": data.planned_event_settings["contractor"].link_url || "",
          "industry professional_link_url": data.planned_event_settings["industry professional"].link_url || "",
          "agency_link_url": data.planned_event_settings["agency"].link_url || "",
          "volunteer_link_url": data.planned_event_settings["volunteer"].link_url || "",
          "other_link_url": data.planned_event_settings["other"].link_url || "",

          loaded: true
        })
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}


export default UpdatePlannedEventSettings;
